import type { EntityConfig } from '../types'

export const merchantEntity: EntityConfig = {
  id: 'merchant',
  displayName: 'Merchant',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'risky', label: 'Risky' },
      { value: 'restricted', label: 'Restricted' },
      { value: 'soon_restricted', label: 'Soon Restricted' },
      { value: 'rejected', label: 'Rejected' },
      { value: 'terminated', label: 'Terminated' },
      { value: 'accounts_to_review', label: 'Accounts to review' },
      { value: 'rule_match', label: 'Rule Match' },
    ],
    options: [
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'pending', label: 'Pending', color: 'warning' },
      { value: 'inactive', label: 'Inactive', color: 'neutral' },
      { value: 'suspended', label: 'Suspended', color: 'warning' },
      { value: 'risky', label: 'Risky', color: 'warning' },
      { value: 'restricted', label: 'Restricted', color: 'error' },
      { value: 'soon_restricted', label: 'Soon Restricted', color: 'warning' },
      { value: 'rejected', label: 'Rejected', color: 'error' },
      { value: 'terminated', label: 'Terminated', color: 'error' },
      { value: 'accounts_to_review', label: 'Accounts to review', color: 'warning' },
      { value: 'rule_match', label: 'Rule Match', color: 'warning' },
      { value: 'failed', label: 'Failed', color: 'error' },
      { value: 'declined', label: 'Declined', color: 'error' },
      { value: 'canceled', label: 'Canceled', color: 'error' },
      { value: 'blocked', label: 'Blocked', color: 'error' },
      { value: 'expired', label: 'Expired', color: 'error' },
    ],
    mappings: {
      all: [],
      active: ['active'],
      risky: ['risky'],
      restricted: ['restricted'],
      soon_restricted: ['soon_restricted'],
      rejected: ['rejected'],
      terminated: ['terminated'],
      accounts_to_review: ['accounts_to_review'],
      rule_match: ['rule_match'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    monthlyVolume: { type: 'amount', urlKey: 'monthlyVolume' },
    country: { type: 'string_array', urlKey: 'country' },
    industry: { type: 'string_array', urlKey: 'industry' },
    riskLevel: { type: 'string_array', urlKey: 'riskLevel' },
    verified: { type: 'boolean', urlKey: 'verified' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'dateRange',
    'monthlyVolume',
  ]
}
